import React from 'react'

const PastAppointments = () => {
  return <></>
}

export default PastAppointments
